import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, faqJsonLd } from "@/lib/seo";
import { FAQS_RETAINER } from "@/lib/service-content/faqs/retainer";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/retainer";

const OFFERS = [
  ["Shopify Starter Retainer", 1495],
  ["Shopify Continuous Improvement Retainer", 2795],
  ["Shopify Growth & Engineering Retainer", 5000],
  ["Shopify Plus Engineering Retainer", 9000],
] as const;

export const Route = createFileRoute("/retainer")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en",
    title: "Shopify Development Retainer: Senior Ongoing Engineering · Shugert",
    description: "Bounded senior Shopify capacity with a prioritized roadmap, persistent context and controlled releases. Plans from $1,495/month; Growth from $5,000.",
    path: PATH,
    altPath: alternatePath(PATH, "es"),
    ogImage: "/og-default-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Retainer", path: PATH }]),
      faqJsonLd(FAQS_RETAINER.en),
      {
        "@context": "https://schema.org",
        "@type": "Service",
        name: "Ongoing Shopify Engineering Retainer",
        url: `https://shugert.com.mx${PATH}`,
        description: "Bounded senior Shopify delivery capacity with a prioritized backlog, staging, validation and explicit operating boundaries.",
        provider: { "@type": "ProfessionalService", name: "Shugert", url: "https://shugert.com.mx" },
        areaServed: [
          { "@type": "Country", name: "United States" },
          { "@type": "Country", name: "Mexico" },
          { "@type": "Country", name: "Spain" },
        ],
        serviceType: "Ongoing Shopify Engineering",
        hasOfferCatalog: {
          "@type": "OfferCatalog",
          name: "Shopify Retainer Tiers",
          itemListElement: OFFERS.map(([name, price]) => ({
            "@type": "Offer",
            priceCurrency: "USD",
            availability: "https://schema.org/InStock",
            category: name.includes("Plus") ? "Shopify Plus Retainer" : "Shopify Retainer",
            priceSpecification: {
              "@type": "UnitPriceSpecification",
              priceCurrency: "USD",
              ...(price >= 5000 ? { minPrice: price } : { price }),
              unitCode: "MON",
              referenceQuantity: { "@type": "QuantitativeValue", value: 1, unitCode: "MON" },
            },
            itemOffered: { "@type": "Service", name, url: `https://shugert.com.mx${PATH}` },
          })),
        },
      },
    ],
  }),
});
